import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import home_logo from "../../assets/images/Tixbook_logo.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faBars, faTimes, faDownload, faUserCircle, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import searchIcon from "../../assets/images/pink-search.svg";
import locationIcon from "../../assets/images/location-pink.svg";
import profileIcon from "../../assets/images/profile-icon.svg";
import { width } from "@fortawesome/free-solid-svg-icons/fa0";
import Form from "../loginForm/form";
import appDownloadIcon from "../../assets/images/app-download-icon.svg";

function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedLocation, setSelectedLocation] = useState("Location");
  const [imageError, setImageError] = useState(false);

  // Check if user is logged in on component mount and listen for login events
  useEffect(() => {
    // Initial check for stored user
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        console.error('Error parsing stored user:', error);
        localStorage.removeItem('user');
        localStorage.removeItem('accessToken');
      }
    }

    // Listen for login events
    const handleUserLogin = (event) => {
      setUser(event.detail);
    };

    // Listen for auth error events (401/Invalid Token)
    const handleAuthError = () => {
      // Clear user state when auth error occurs
      setUser(null);
    };

    window.addEventListener('userLogin', handleUserLogin);
    window.addEventListener('authError', handleAuthError);

    return () => {
      window.removeEventListener('userLogin', handleUserLogin);
      window.removeEventListener('authError', handleAuthError);
    };
  }, []);

  // Handle successful login (for Google login)
  const handleLoginSuccess = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };
  
  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('accessToken');
    setUser(null);
    navigate('/');
  };

  // Toggle Mobile Menu
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  useEffect(() => {
  const savedLocation = localStorage.getItem("selectedLocation");
  if (savedLocation) {
    setSelectedLocation(savedLocation);
  }
}, []);

const handleLocationChange = (city) => {
  setSelectedLocation(city);
  localStorage.setItem("selectedLocation", city);
};

  // Get user initial for avatar
  const getUserInitial = () => {
    if (!user) return '';
    // Use name if available, otherwise use first letter of email
    const displayName = user.name || user.email;
    return displayName.charAt(0).toUpperCase();
  };

  // Check if a link is active based on current location
  const isActiveLink = (path) => {
    if (path === '/') {
      // Home page can be '/' or exact match
      return location.pathname === '/' || location.pathname === path;
    }
    return location.pathname === path;
  };

  // Get active link styles
  const getActiveLinkStyle = (path) => {
    return isActiveLink(path) ? { color: 'var(--primary-color)' } : {};
  };

  return (
    <><nav className="navbar navbar-expand-lg navbar-fixed-top">
      <div className="container-fluid container-xxl px-md-5 py-3">
        {/* Logo */}
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img src={home_logo} alt="Tixbook" />
        </Link>
        <div className="d-none d-lg-flex align-items-center justify-content-end w-100">
        <div className="dropdown me-3 ps-4 d-none">
          <button className="border-0 d-flex align-items-center" type="button" data-bs-toggle="dropdown">
  <img src={locationIcon} className="me-2" alt="location" /> 
  {selectedLocation} 
  <FontAwesomeIcon icon={faChevronDown} className="ms-2" />
</button>
          <ul className="dropdown-menu">
  {["Birmingham", "Liverpool", "Leeds", "Manchester", "London", "Sheffield", "Bristol", "Bradford", "Edinburgh"].map((city) => (
    <li key={city}>
      <button 
        className="dropdown-item" 
        type="button" 
        onClick={() => handleLocationChange(city)}
      >
        {city}
      </button>
    </li>
  ))}
</ul>
        </div>

        {/* Search Bar */}
        {/* <form className=" me-3 position-relative search-form">
          <input className="form-control search-bar" type="search" placeholder="Search for Events" />
          <button className="btn text-primary search-icon" type="submit">
            <img src={searchIcon} alt="search"></img>
          </button>
        </form> */}

        {/* Navbar Links */}
        <ul className="navbar-nav ms-auto main-links">
          <li className="nav-item">
            <Link 
              className="nav-link" 
              to="/events" 
              style={getActiveLinkStyle('/events')}
            >
              Events
            </Link>
          </li>
          <li className="nav-item">
            <Link 
              className="nav-link me-4" 
              to="/contact-us" 
              style={getActiveLinkStyle('/contact-us')}
            >
              Contact Us
            </Link>
          </li>
          {/* <li className="nav-item"><Link className="nav-link" to="#">Today's Events</Link></li>
          <li className="nav-item"><Link className="nav-link me-4" to="#">Create Event</Link></li> */}
        </ul>

        {/* Get the App Button */}
        {/* <Link to="#" className="btn btn-primary">
          <FontAwesomeIcon icon={faDownload} className="me-1" />
          Get the App
        </Link> */}

        {/* User Icon - Show different UI based on login status */}
        {user ? (
          <div className="dropdown">
            <button 
              className="btn btn-link dropdown-toggle p-0 d-flex align-items-center" 
              type="button" 
              id="userDropdown" 
              data-bs-toggle="dropdown" 
              aria-expanded="false"
            >
              <div 
                className="bg-primary rounded-circle d-flex align-items-center justify-content-center ms-2" 
                style={{ 
                  width: '32px', 
                  height: '32px', 
                  color: 'white',
                  fontSize: '16px',
                  fontWeight: '500'
                }}
              >
                {getUserInitial()}
              </div>
              {/* <span className="text-dark">{user.name || user.email}</span> */}
            </button>
            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
              <li><a className="dropdown-item" href="/profile">My Profile</a></li>
              <li><a className="dropdown-item" href="/my-bookings">My Bookings</a></li>
              <li><hr className="dropdown-divider" /></li>
              <li><button className="dropdown-item" onClick={handleLogout}>Logout</button></li>
            </ul>
          </div>
        ) : (
          <Link to="#" className="ms-4">
            <img src={profileIcon} alt="Profile" data-bs-toggle="modal" data-bs-target="#profileModal" />
          </Link>
        )}
      </div>

     

      {/* Mobile Menu Button */}
      <button className="d-lg-none btn border-0" onClick={toggleMobileMenu}>
        <FontAwesomeIcon icon={isMobileMenuOpen ? faTimes : faBars} size="xl" />
      </button>
      </div>
    </nav>
    
    <div className={`mobile-menu ${isMobileMenuOpen ? "open" : ""}`}>
      {/* Mobile Navigation Links */}
      <div className="dropdown me-3 ps-4 d-none">
          <button className="border-0 d-flex align-items-center" type="button" data-bs-toggle="dropdown">
  <img src={locationIcon} className="me-2" alt="location" /> 
  {selectedLocation} 
  <FontAwesomeIcon icon={faChevronDown} className="ms-2" />
</button>
          <ul className="dropdown-menu">
  {["Birmingham", "Liverpool", "Leeds", "Manchester", "London", "Sheffield", "Bristol", "Bradford", "Edinburgh"].map((city) => (
    <li key={city}>
      <button 
        className="dropdown-item" 
        type="button" 
        onClick={() => handleLocationChange(city)}
      >
        {city}
      </button>
    </li>
  ))}
</ul>
        </div>

        

        {/* Search Bar */}
        {/* <form className=" ms-4 position-relative search-form">
          <input className="form-control search-bar" type="search" placeholder="Search for Events" />
          <button className="btn text-primary search-icon" type="submit">
            <img src={searchIcon} alt="search"></img>
          </button>
        </form> */}

      


      {/* User Icon/Profile in mobile view */}
     <div className="mt-4 ps-4 mob-profile">
  {user ? (
    <>
      <div className="d-flex align-items-center mb-2">
        {user.picture ? (
          <img 
            src={user.picture} 
            alt="User" 
            className="rounded-circle" 
            style={{ width: '32px', height: '32px' }} 
            onError={() => setImageError(true)}
          />
        ) : (
          <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center" 
               style={{ width: '32px', height: '32px', color: 'white' }}>
            {getUserInitial()}
          </div>
        )}
        <span className="ms-2">{user.name}</span>
      </div>

      <ul className="list-unstyled mobile-nav-links ps-0 mb-0 pb-0">
        <li>
          <Link 
            to="/profile" 
            onClick={() => setIsMobileMenuOpen(false)}
            style={getActiveLinkStyle('/profile')}
          >
            My Profile
          </Link>
        </li>
        <li>
          <Link 
            to="/my-bookings" 
            onClick={() => setIsMobileMenuOpen(false)}
            style={getActiveLinkStyle('/my-bookings')}
          >
            My Bookings
          </Link>
        </li>
      </ul>
    
    
    </>
  ) : (
    <>
    <div className="d-flex align-items-center pb-4 mob-profile" 
         data-bs-toggle="modal" 
         data-bs-target="#profileModal"
         onClick={() => setIsMobileMenuOpen(false)}
         style={{ cursor: 'pointer' }}> 
    <img 
      src={profileIcon} 
      alt="Profile"
    />
    <p className="ms-2 mb-0">Profile</p>
    </div>
   
    </>
  )}

<ul className="mobile-nav-links mb-0 ps-0 pb-0 pt-0">
        <li>
          <Link 
            to="/events" 
            onClick={() => setIsMobileMenuOpen(false)}
            style={getActiveLinkStyle('/events')}
          >
            Events
          </Link>
        </li>
        <li>
          <Link 
            to="/contact-us" 
            onClick={() => setIsMobileMenuOpen(false)}
            style={getActiveLinkStyle('/contact-us')}
          >
            Contact Us
          </Link>
        </li>
      </ul>
</div>

{user ? (
  <>
  <div className="ps-4">
  <button className="btn btn-link ms-2 ps-5" onClick={handleLogout}>
        <FontAwesomeIcon icon={faSignOutAlt} className="pe-2" /> Logout
      </button> 
  </div>
      
  </>
) : (
  <></>
)}


      
      
  {/* Get the App Button */}
      <Link to="#" className="btn btn-primary mx-3 mt-4 d-none " onClick={() => setIsMobileMenuOpen(false)}>
        <FontAwesomeIcon icon={faDownload} className="me-1" /> Get the App
      </Link>
    </div>

    {isMobileMenuOpen && <div className="overlay" onClick={() => setIsMobileMenuOpen(false)}></div>}

    {/* Login Modal */}
    <div className="modal fade" id="profileModal" tabIndex="-1" aria-labelledby="profileModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-md modal-dialog-centered">
        <div className="modal-content">
          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          <div className="modal-body">
            <Form onLoginSuccess={handleLoginSuccess} />
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default Navbar;